var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticClass: "user-op-log-dialog",
      attrs: {
        width: _vm.dialogWidth,
        title: "Operation History",
        visible: _vm.dialogVisible,
        "z-index": 2000,
        scrollbar: false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        opened: _vm.onOpened,
        closed: _vm.onClosed,
      },
    },
    [
      _c("div", { staticClass: "op-log-content" }, [
        _c(
          "div",
          { staticClass: "table-wrap" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                ref: "table",
                attrs: {
                  data: _vm.tableData,
                  "element-loading-text": "Loading...",
                  "row-key": _vm.rowKeyHandler,
                  size: "mini",
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "expand", width: "40" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "field-changes-wrap" },
                            [
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: row.fieldChanges,
                                    border: "",
                                    size: "mini",
                                    "show-header": true,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "fieldName",
                                      label: "Field Name",
                                      "min-width": "100",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "oldValue",
                                      label: "Old Value",
                                      "min-width": "120",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "newValue",
                                      label: "New Value",
                                      "min-width": "120",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Update Type",
                    "min-width": "100",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.updateTypeTagType(row.updateType),
                                effect: "dark",
                                size: "mini",
                              },
                            },
                            [_vm._v(" " + _vm._s(row.updateType) + " ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Update Time",
                    "min-width": "140",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " + _vm._s(_vm.formatTime(row.updateTime)) + " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "operatorName",
                    label: "Operator Name",
                    "min-width": "100",
                    "show-overflow-tooltip": "",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrap" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 25, 50, 100],
                "page-size": _vm.pageSize,
                layout: _vm.paginationLayout,
                total: _vm.total,
                small: "",
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "el-button",
              {
                on: {
                  click: function ($event) {
                    _vm.dialogVisible = false
                  },
                },
              },
              [_vm._v("Close")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }